// HTML escaping for the printables (quote, change order, T&M billing summary…) that
// build a page as a string and hand it to a print window. Anything that came from a
// person — a job name, a scope paragraph, a ticket title — is text, never markup.
//
// escHtml(s)  → one string, safe inside an element or a quoted attribute.
// escDeep(v)  → the same value with every string inside it escaped: objects and
//               arrays are walked, numbers/booleans/dates are left alone. A string
//               that is itself JSON (a bid's drill_scope_items, a ticket's up_items)
//               is parsed, escaped inside, and re-serialised, so JSON.parse on it
//               downstream still works and its labels come out escaped. Run a record
//               through it once at the top of a printable and every `${row.field}`
//               below is safe without touching each one.
export const escHtml = s => String(s == null ? '' : s)
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

export function escDeep(v) {
  if (v == null) return v;
  if (typeof v === 'string') {
    const t = v.trim();
    if (t.length > 1 && (t[0] === '{' || t[0] === '[')) {
      try { return JSON.stringify(escDeep(JSON.parse(t))); } catch { /* not JSON — plain text */ }
    }
    return escHtml(v);
  }
  if (Array.isArray(v)) return v.map(escDeep);
  if (typeof v === 'object') {
    if (v instanceof Date) return v;
    const out = {};
    for (const k of Object.keys(v)) out[k] = escDeep(v[k]);
    return out;
  }
  return v;
}
